const terms = `財產保險投保人須知

玆依據「金融消費者保護法」及「金融服務業提供金融商品或服務前說明契約重要內容及揭露風險辦法」之規定，美商安達產物保險股份有限公司台灣分公司（下稱本分公司）敬告要（被）保險人（下稱貴客戶）於投保前須特別注意下列事項：
一、	投保時，業務員會告知您授權範圍及提供審閱保險單條款。為明瞭投保的內容，貴客戶請務必要求業務員出示相關文件並詳細告知，以確保本身的權益。此外，本分公司亦於<a href="https://www.chubb.com/tw-zh/" target="_blank" rel="noopener noreferrer">官網</a>及<a href="https://ins-info.ib.gov.tw/customer/announceinfo.aspx" target="_blank" rel="noopener noreferrer">公開資訊觀測站</a>揭露本保險商品之保單條款，如業務員未主動提供本保險商品保單條款或 貴客戶未能取得本保險商品保單條款時，請務必要求業務員提供或聯繫本分公司。
二、	要保人及被保險人應誠實告知相關事項，若有違反告知義務時，本分公司得解除保險契約；保險事故發生後亦同。保險契約係最大誠信契約，故要保人及被保險人對於要保書書面詢問事項應據實說明，不得有隱匿或遺漏不為說明，或為不實之說明。若因此以致減少本分公司變更或減少危險之估計時，依保險法第64條規定，本分公司有解除契約之權，同時可依同法第25條規定無須返還已繳交之保險費。
三、	除外責任：保險公司依照保險法的規定，對於被保險人的故意行為，不負給付保險金之責。此外，在保險單條款中會有詳細的除外責任及不保事項，消費者請務必審閱清楚。
四、貴客戶對保險契約之權利、行使、變更及終止方式：
(一) 權利行使：
1.	被保險標的發生保險契約承保範圍之事故時，貴客戶或受益人應依保險法相關法令與保險契約之約定與程序通知本分公司。
2.	由保險契約所生之權利，自得為請求之日起，經二年不行使而消滅。
(二)	契約變更、解除及終止：貴客戶得隨時以書面通知本分公司，辦理變更、解除及終止保險契約，但非經雙方同意且經本分公司簽批者不生效力。
五、	本分公司對於保險契約之重要權利、義務及責任：本分公司依據主管機關核定之各項規定承保並收取保險費；於承保危險事故發生時，依契約及相關法令規定，依承保責任負給付保險金之義務。 
六、	貴客戶於繳交保險費外，無須另繳交其他費用或違約金。
七、	本分公司保險商品皆依保險相關法令辦理，並受財團法人保險安定基金之保障。
八、	因投保契約所生紛爭之處理方式及申訴之管道：要保人或被保險人因投保之保險契約發生爭議，可以向本分公司（免費申訴電話：0800608989）、依金融消費者保護法規設立之爭議處理機構或金融監督管理委員會申訴。
九、	本分公司依美國、聯合國、歐盟及中華民國等經濟制裁相關法令規定，就涉及伊朗、敘利亞、古巴、北韓、北蘇丹、克里米亞、委內瑞拉、緬甸、俄羅斯、白俄羅斯、烏克蘭之頓涅茨克人民共和國（DNR）地區、盧甘斯克人民共和國（LNR）地區，或其他受制裁國家／地區所發生之保險事故，本分公司不予承保及理賠。前述經濟制裁之國家或地區，應依各國政府、國際組織或主管機關於其官方網站或公告所公布之最新名單為準。
十、投保安達產物行動裝置保險(分期交付型)，專案繳費方式一經選定，中途無法辦理變更。
`;

export default terms;
